import React, { Component } from "react";
import { Api } from "../../utils/api";
import Chart from "react-apexcharts";
import moment from "moment";

class AdmissionsPaidVsNotPaid extends Component {
  constructor() {
    super();
    this.api = new Api();
  }

  state = {
    chart: {
      title: {
        text: "Admitidos cobrados vs. por cobrar",
        align: "center",
        margin: 40,
        style: {
          fontSize: "18px",
          fontWeight: "bold",
          color: "#263238",
        },
      },
      colors: ["#87cefa"],
      plotOptions: {
        radialBar: {
          startAngle: -90,
          endAngle: 90,
          track: {
            background: "#d7f3f7",
            startAngle: -90,
            endAngle: 90,
          },
          dataLabels: {
            name: {
              show: true,
              label: "Admitidos cobrados",
            },
            value: {
              show: true,
              fontSize: "18px",
              formatter: function (val) {
                return val + "%";
              },
            },
            total: {
              show: true,
              label: "Admitidos cobrados",
            },
          },
        },
      },
      fill: {
        type: "gradient",
        gradient: {
          shade: "dark",
          type: "horizontal",
          gradientToColors: ["#87D4F9"],
          stops: [0, 100],
        },
      },
      stroke: {
        lineCap: "butt",
      },
    },
  };

  render() {
    let cobrados = this.props.admissionsPaidVsNotPaid
      ? parseInt(this.props.admissionsPaidVsNotPaid[0].cobrados)
      : 0;
    let por_cobrar = this.props.admissionsPaidVsNotPaid
      ? parseInt(this.props.admissionsPaidVsNotPaid[0].por_cobrar)
      : 0;
    let total_admissoes = cobrados + por_cobrar;
    let percentagem_cobrados =
      cobrados === 0
        ? 0
        : parseFloat((cobrados * 100) / total_admissoes).toFixed(1);

    return (
      <div class="ml-4 mt-3">
        <Chart
          title={this.state.title}
          options={this.state.chart}
          series={[percentagem_cobrados]}
          type="radialBar"
          width="480"
          height="480"
        />
        <br /> <br />
        {this.props.filter_date_admissions_paid_vs_not_paid == null ||
        this.props.filter_date_admissions_paid_vs_not_paid ===
          moment().subtract(1, "month").format("YYYY-MM-DD") ? (
          <div class="subtitle-grafs text-center">
            <u>Dados referentes aos últimos 30 dias</u>
          </div>
        ) : (
          <div class="subtitle-grafs text-center">
            <u>Dados referentes ao período de tempo referido no filtro</u>
          </div>
        )}
        <div class="subtitle-grafs mt-1 text-center">
          <strong>Número de admissões cobradas: </strong>
          {cobrados}
        </div>
        <div class="subtitle-grafs text-center">
          <strong>Número de admissões por cobrar: </strong>
          {por_cobrar}
        </div>
        <div class="subtitle-grafs text-center">
          <strong>Total de admissões: </strong>
          {total_admissoes}
        </div>
      </div>
    );
  }
}
export default AdmissionsPaidVsNotPaid;
